// components/ChatAvatar.jsx
import React from 'react';
import { useFileLoader } from '../hooks/useFileLoader';
import { getAvatarColor, getInitials } from '../utils/userHelpers';

function ChatAvatar({ 
    chat,     
    className = 'chat-avatar',
    imgClassName = 'avatar-img',
    placeholderClassName = 'avatar-placeholder' 
}) {
    const { fileUrl, loading } = useFileLoader(chat.avatar);
    const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };
    
    // Если загрузка или нет аватара
    if (loading || !fileUrl) {              
               
        return (
            <div className={className}>
                <div 
                    className={ placeholderClassName}
                     style={{ 
                        backgroundColor: getAvatarColor(hashCode(chat.chat_id) || 0), 
                                             
                    }}
                >
                    {getInitials(chat.title || 'Чат')}
                </div>
            </div>
        );
    }
    
    return (
        <div className={className} >
            <img 
                src={fileUrl} 
                alt={chat?.title || 'Avatar'} 
                className={imgClassName}                
            />
        </div>
    );
}
export default ChatAvatar;